import { TFPageContent, TFPageHeader } from '@tf/shared';
import { T } from '@tf/utils';
import { Navigate } from 'react-router-dom';
import { TokensTable } from '@/components/settings/TokensTable';
import { AddTokenButton } from '@/components/settings/TokensTable/AddTokenButton';
import { appStore } from '@/core/stores';
import { UserCapabilities } from '@/core/types';
import { useCurrentUserCapabilityCheck } from '@/core/utils';

export const TokenListRoute = () => {
	const canManageApiTokens = useCurrentUserCapabilityCheck(UserCapabilities.CAN_MANAGE_API_TOKENS);

	const tenant = appStore.tenant?.get();
	T.assertNotNullish(tenant, 'no tenant in appStore');

	if (!canManageApiTokens) {
		return <Navigate to="/" replace />;
	}

	return (
		<>
			<TFPageHeader tenant={tenant} title="API Tokens" toolbar={<AddTokenButton />} />
			<TFPageContent>
				<TokensTable />
			</TFPageContent>
		</>
	);
};
